import { render, staticRenderFns } from "./my-exams.vue?vue&type=template&id=c6ed01bc"
import script from "./my-exams.vue?vue&type=script&lang=js"
export * from "./my-exams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports